module.exports = __webpack_public_path__ + "static/img/bzpaibanjihua2.36c9058c.png";